import React, { useEffect, useState, useRef } from "react";
import "./NavigationBar.css";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import Cookies from "js-cookie";
import logo from "../../assets/images/logo 2.png";
import logoWhite from "../../assets/images/logo.png";
import { useTranslation } from "../../contexts/TranslationContext";
import axios from "axios";
import { axiosGet, axiosPost } from "../../utils/apis/api";
import Select from "react-select";

import { useGlobal } from '../../contexts/GlobalContext';



// Function to get cookie by name

const NavigationBar = ({ url }) => {
  const { packageNotFound } = useGlobal();

  const hasCookies = Cookies.get("api_key") && Cookies.get("api_secret") ;
  const [isScrolled, setIsScrolled] = useState(false);
  const [innerPageScroll, setInnerPageScroll] = useState(false)

  const [innerPage, setInnerPage] = useState(false)

  const [currentLanguage, setCurrentLanguage] = useState("en");
    // const [currentLanguage, setCurrentLanguage] = useState(Cookies.get("preferred_language") || "en");


  const location = useLocation();
  const { t, fetchTranslations } = useTranslation();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // const preferredLang = Cookies.get("preferred_language") || "en";
  const [preferredLang, setPreferredLang] = useState(Cookies.get("preferred_language") || "en");




  const apiKey = Cookies.get("api_key");
  const apiSecret = Cookies.get("api_secret");

  const [currentCountry, setCurrentCountry] = useState("");
  const [currentCurrency, setCurrentCurrency] = useState("");
  // const [countries, setCountries] = useState([]);
  // const [selectedCountry, setSelectedCountry] = useState(
  //   Cookies.get("country") || ""
  // );

  // const options = countries.map((c) => ({
  //   value: c.country_code,
  //   label: `${c.location_name} (${c.country_code.toUpperCase()})`,
  //   short: c.country_code.toUpperCase(), 
  //   lang: c.country_lang || "en",
  //   currency: c.country_currency || "USD",
  // }));

  // useEffect(() => {
  //   const fetchCountries = async () => {
  //     try {
  //       const res = await fetch(
  //         "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.locations?location_type=Country&limit=200"
  //       );
  //       const json = await res.json();
  //       if (json.result && json.result.locations) {
  //         setCountries(json.result.locations);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching countries:", error);
  //     }
  //   };

  //   fetchCountries();
  // }, []);


  // const handleCountryChange = (selected) => {
  //   setSelectedCountry(selected.value);

  //   Cookies.set("country", selected.value, { expires: 30 });
  //   Cookies.set("preferred_currency", selected.currency, { expires: 30 });
  //   Cookies.set("preferred_language", selected.lang, { expires: 30 });

  //   console.log("Country changed:", {
  //     country: selected.value,
  //     currency: selected.currency,
  //     language: selected.lang,
  //   });

  //   window.location.reload();
  // };

    const [currencies, setCurrencies] = useState([]);
  // const [selectedCurrency, setSelectedCurrency] = useState(
  //   Cookies.get("preferred_currency") || ""
  // );
  const preferredCurrency = Cookies.get("preferred_currency") || "";


  const options = currencies.map((c) => ({
    value: c.name, 
    label: `${c.name} ${c.symbol || ""}`, 
    short: c.name,   
    symbol: c.symbol,
    format: c.number_format,
  }));

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await fetch(
          "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.currencies"
        );
        const json = await res.json();
        if (json.result) {
          setCurrencies(json.result);
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };

    fetchCurrencies();
  }, []);


  // const handleCurrencyChange = (selected) => {
  //   setSelectedCurrency(selected.value);

  //   Cookies.set("preferred_currency", selected.value, { expires: 30 });

  //   console.log("Currency changed:", {
  //     currency: selected.value,
  //     symbol: selected.symbol,
  //     format: selected.format,
  //   });

  //   window.location.reload(); 
  // };


  const handleLogout = async () => {
    try {
      // Send logout request to backend
      await fetch("https://viaggioerp.inter-netsys.com/api/method/logout", {
        method: "POST",
        credentials: "include", // مهم لإرسال الكوكيز مع الطلب إذا كان يعتمد عليها
      });
    } catch (error) {
      console.error("Logout API error:", error);
    }

    // Remove all authentication-related cookies
    Cookies.remove("sid");
    Cookies.remove("api_key");
    Cookies.remove("api_secret");
    Cookies.remove("user_id");
    Cookies.remove("full_name");
    Cookies.remove("user_image");
    Cookies.remove("username");

    // Close the dropdown
    setShowDropdown(false);

    // Update login state immediately
    setIsLoggedIn(false);

    // Redirect to home page
    window.location.href = "/home";
  };

  useEffect(() => {
    const hasUserCookie = apiSecret && apiKey;
    setIsLoggedIn(hasUserCookie);
  }, [location.pathname]);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  // Initialize language from cookie
  useEffect(() => {
    // const preferredLang = Cookies.get("preferred_language");
    console.log("preferredLang",preferredLang);
    if (preferredLang) {
      setCurrentLanguage(preferredLang);
    }
  }, []);

  useEffect(() => {
    console.log("preferredLang",preferredLang);
    // const preferredLang = Cookies.get("preferred_language") || "en";
    setCurrentLanguage(preferredLang);
    
    // Set HTML attributes based on language
    document.documentElement.setAttribute("lang", preferredLang);
    console.log("preferredLang",preferredLang);
    document.documentElement.setAttribute("dir", preferredLang === 
      "ar" ? "rtl" : "ltr");
  }, [preferredLang]);

  

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = 1;
      const screenWidth = window.innerWidth;
      const currentPath = location.pathname;

      const isInnerPage = currentPath === "/about" || currentPath === "/privacy";
      setInnerPage(isInnerPage && screenWidth > 992)

      const isHomeOrPackageDetails =
        currentPath === "/" ||
        currentPath === "/home" ||
        isInnerPage ||
        currentPath.startsWith("/package/");
      const scrolledDueToPath = !isHomeOrPackageDetails;


      setInnerPageScroll(scrollPosition > scrollThreshold);
      setIsScrolled(
        packageNotFound ||
        scrolledDueToPath ||
          scrollPosition > scrollThreshold ||
          screenWidth < 992
      );
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [location.pathname,packageNotFound]);

  const isActive = (path) => location.pathname === path;

  //   const changeLanguage = async (lang) => {
  //   const previousLang = Cookies.get('preferred_language') || 'en';

  //   // Update state immediately for UI responsiveness
  //   setCurrentLanguage(lang);

  //   fetch(`${url}/api/method/alltimes.www.api.set_language?name=${lang}`)
  //     .then(response => {
  //       if (response.ok) {
  //         // Set cookie only on success
  //         Cookies.set('preferred_language', lang, { path: '/', expires: 365 });
  //           await fetchTranslations(lang);

  //         // Reload page to apply language changes
  //         window.location.reload();
  //       } else {
  //         console.error('Failed to change language');
  //         setCurrentLanguage(previousLang);
  //       }
  //     })
  //     .catch(error => {
  //       console.error('Error:', error);
  //       setCurrentLanguage(previousLang);
  //     });
  // };

  // const changeLanguage = async (lang) => {
  //   const previousLang = Cookies.get('preferred_language') || 'en';
  //   setCurrentLanguage(lang);

  //   try {
  //     const response = await fetch(`${url}/api/method/alltimes.www.api.set_language`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ name: lang }),
  //     });

  //     if (response.ok) {
  //       document.documentElement.setAttribute('lang', lang);

  //       Cookies.remove('preferred_language', { path: '/' });
  //       Cookies.set('preferred_language', lang, { path: '/', expires: 365 });

  //       await fetchTranslations(lang);
  //       window.location.reload();
  //     } else {
  //       console.error('Failed to change language');
  //       setCurrentLanguage(previousLang);
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //     setCurrentLanguage(previousLang);
  //   }
  // };

  // const changeLanguage = async (lang) => {
  //   const previousLang = Cookies.get('preferred_language') || 'en';
  //   setCurrentLanguage(lang);

  //   try {
  //     const response = await axiosGet(
  //       '/api/method/alltimes.www.api.set_language',
  //       { name: lang },
  //       { "Content-Type": "application/json" }
  //     );

  //     if (response) {
  //       document.documentElement.setAttribute('lang', lang);

  //       Cookies.remove('preferred_language', { path: '/' });
  //       Cookies.set('preferred_language', lang, { path: '/', expires: 365 });

  //       await fetchTranslations(lang); // <- Also use axiosPost in here if needed
  //       window.location.reload();
  //     } else {
  //       console.error('Failed to change language');
  //       setCurrentLanguage(previousLang);
  //     }
  //   } catch (error) {
  //     console.error('Error changing language:', error);
  //     setCurrentLanguage(previousLang);
  //   }
  // };

  //   const changeCountry = async (country) => {
  //   const previousCountry = Cookies.get("country");
  //   setCurrentCountry(country);
    
  //   try {
  //     const response = await axiosPost(
  //       "/api/method/alltimes.www.api.set_country",
  //       { name: country },
  //       {
  //         "Content-Type": "application/json",
  //       }
  //     );
      
  //     if (response.status === 200) {
  //       document.documentElement.setAttribute("country", country);

  //       // Cookies.set("preferred_language", lang, { path: "/", expires: 365 });

  //       window.location.reload();
  //     } else {
  //       console.error("Failed to change country");
  //       setCurrentCountry(previousCountry);
  //     }
  //   } catch (error) {
  //     console.error("Error changing country:", error);
  //     setCurrentCountry(previousCountry);
  //   }
  // };

    const changeCurrency = async (currency) => {
    const previousCurrency = Cookies.get("preferred_currency");
    setCurrentCurrency(currency);
    
    try {
      const response = await axiosPost(
        "/api/method/alltimes.www.api.set_currency",
        { name: currency },
        {
          "Content-Type": "application/json",
        }
      );
      console.log(response);
      
      if (response.status === 200) {
        // document.documentElement.setAttribute("currency", currency);

        Cookies.set("preferred_currency", currency, { path: "/", expires: 365 });
        window.location.reload();

      } else {
        console.error("Failed to change currency");
        setCurrentCurrency(previousCurrency);
      }
    } catch (error) {
      console.error("Error changing currency:", error);
      setCurrentCurrency(previousCurrency);
    }
  };

  const changeLanguage = async (lang) => {
    const previousLang = Cookies.get("preferred_language");
    console.log("previousLang",previousLang);
    setCurrentLanguage(lang);
    console.log("currentLanguage",currentLanguage);
    
    try {
      const response = await axiosPost(
        "/api/method/alltimes.www.api.set_language",
        { name: lang },
        {
          "Content-Type": "application/json",
        }
      );
      
      if (response.status === 200) {
        document.documentElement.setAttribute("lang", lang);

        Cookies.set("preferred_language", lang, { path: "/", expires: 365 });

        await fetchTranslations(lang);
        window.location.reload();
      } else {
        console.error("Failed to change language");
        setCurrentLanguage(previousLang);
      }
    } catch (error) {
      console.error("Error changing language:", error);
      setCurrentLanguage(previousLang);
    }
  };

  // const changeLanguage = async (lang) => {
  //   const previousLang = Cookies.get('preferred_language') || 'en';
  //   setCurrentLanguage(lang);

  //   try {
  //     const data = await axiosGet('/api/method/alltimes.www.api.set_language',
  //       { name: lang },
  //       { "Content-Type": "application/json" }
  //     );

  //     if (data) {
  //       document.documentElement.setAttribute('lang', lang);

  //       Cookies.remove('preferred_language', { path: '/' });
  //       Cookies.set('preferred_language', lang, { path: '/', expires: 365 });

  //       await fetchTranslations(lang);
  //       window.location.reload();
  //     } else {
  //       console.error('Failed to change language');
  //       setCurrentLanguage(previousLang);
  //     }
  //   } catch (error) {
  //     console.error('Error changing language:', error);
  //     setCurrentLanguage(previousLang);
  //   }
  // };

  // if (!isLoggedIn) return null;


    // دالة لمراقبة تغيّر الكوكيز
  useEffect(() => {
  const checkLanguageChange = () => {
    const langCookie = Cookies.get("preferred_language") || "en";
    if (langCookie !== currentLanguage) {
      console.log("Language changed from", currentLanguage, "to", langCookie);
      setCurrentLanguage(langCookie); 
      setPreferredLang(langCookie) ;
      document.documentElement.setAttribute("lang", langCookie);
      document.documentElement.setAttribute("dir", langCookie === "ar" ? "rtl" : "ltr");
      fetchTranslations(langCookie); 
    }
  };

  checkLanguageChange();
  const interval = setInterval(checkLanguageChange, 1000);

  return () => clearInterval(interval);
}, [currentLanguage, fetchTranslations]);


  return (
    <Navbar
      expand="lg"
      // className={`website-nav ${isScrolled ? "website-nav-scrolled" : ""} ${
      //   innerPage ? "inner-page-nav" : ""
      // }`}
      className={`website-nav 
    ${isScrolled ? "website-nav-scrolled" : ""} 
    ${innerPage && !isScrolled ? "inner-page-nav" : ""} 
    ${innerPage && isScrolled ? "inner-page-nav-scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand href="/home">
          {/* <img
            className={`nav-logo`}
            src={isScrolled ? logo : logoWhite}
            alt="Logo"
          /> */}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <div className="navbar-collapse-contianer">
            <Nav className="">
              <Nav.Link href="/home" active={isActive("/home")}>
                {t("Home")}
              </Nav.Link>
              {/* <Nav.Link href="/hotels" active={isActive("/hotels")}>
                {t("Hotels")}
              </Nav.Link>
              <Nav.Link href="/flights" active={isActive("/flights")}>
                {t("Flights")}
              </Nav.Link> */}
              <Nav.Link href="/categories" active={isActive("/categories")}>
                {t("Packages")}
              </Nav.Link>

              <Nav.Link as={Link} to="/about" active={isActive("/about")}>
                {/* {preferredLang === "ar" ? "حولنا" : "About Us"} */}
                {t("AboutUs")}
              </Nav.Link>

              <Nav.Link href="/services" active={isActive("/services")}>
                {t("Services")}
              </Nav.Link>

              <Nav.Link as={Link} to="/hotel" active={isActive("/hotel")}>
                {/* {preferredLang === "ar" ? "فنادق" : "Hotels"} */}
                {t("Hotels")}
              </Nav.Link>
               {/* <Nav.Link as={Link} to="/flight" active={isActive("/flight")}>
                // {preferredLang === "ar" ? "الرحلات الجوية" : "Flights"}
                 {t("Flights")}
              </Nav.Link> */}

              {/* <Nav.Link href="/travel" active={isActive("/travel")}>
                {t("TravelServices")}
              </Nav.Link> */}
              {/* <Nav.Link href="/about" active={isActive("/about")}>
                {t("AboutUs")}
              </Nav.Link> */}

              <Nav.Link href="/contact" active={isActive("/contact")}>
                {t("ContactUs")}
              </Nav.Link>
            </Nav>

            <div className="nav-contact-info">
              <div className="nav-contact-info-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="14"
                  viewBox="0 0 12 14"
                  fill="none"
                >
                  <path
                    d="M11.3679 9.97271L7.96888 9.04733L6.06349 10.4507C4.34378 9.21994 3.05884 7.47536 2.39355 5.46798L4.30649 4.05904L4.42895 0.551652L0.811638 0.00283252C-0.583104 6.62823 4.07811 12.9568 10.8191 13.59L11.3679 9.97271Z"
                    fill={`${isScrolled ? "#494949" : "#fff"}`}
                  />
                </svg>
                <div className="nav-contact-info-num">920022631</div>
              </div>
              <div className="nav-contact-info-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.7075 7.19099C8.5585 7.11649 7.828 6.75749 7.692 6.70749C7.556 6.65799 7.457 6.63349 7.3575 6.78249C7.2585 6.93049 6.974 7.26549 6.8875 7.36449C6.8005 7.46399 6.714 7.47599 6.5655 7.40199C6.417 7.32699 5.938 7.17049 5.3705 6.66449C4.929 6.27049 4.6305 5.78399 4.544 5.63499C4.4575 5.48649 4.5345 5.40599 4.609 5.33199C4.676 5.26549 4.7575 5.15849 4.832 5.07199C4.9065 4.98499 4.931 4.92299 4.9805 4.82349C5.0305 4.72449 5.0055 4.63799 4.968 4.56349C4.931 4.48899 4.634 3.75749 4.51 3.45999C4.3895 3.17049 4.267 3.20999 4.176 3.20499C4.089 3.20099 3.99 3.19999 3.891 3.19999C3.792 3.19999 3.631 3.23699 3.495 3.38599C3.3585 3.53449 2.975 3.89399 2.975 4.62549C2.975 5.35649 3.507 6.06299 3.5815 6.16249C3.656 6.26149 4.629 7.76249 6.1195 8.40599C6.4745 8.55899 6.751 8.65049 6.9665 8.71849C7.3225 8.83199 7.6465 8.81599 7.9025 8.77749C8.1875 8.73499 8.7815 8.41799 8.9055 8.07099C9.029 7.72399 9.029 7.42649 8.992 7.36449C8.955 7.30249 8.856 7.26549 8.707 7.19099H8.7075ZM5.9965 10.8925H5.9945C5.10922 10.8927 4.24019 10.6547 3.4785 10.2035L3.2985 10.0965L1.4275 10.5875L1.927 8.76349L1.8095 8.57649C1.31457 7.78866 1.05265 6.87688 1.054 5.94649C1.055 3.22149 3.272 1.00449 5.9985 1.00449C7.3185 1.00449 8.5595 1.51949 9.4925 2.45349C9.95269 2.91178 10.3174 3.45677 10.5656 4.05694C10.8138 4.6571 10.9406 5.30053 10.9385 5.94999C10.9375 8.67499 8.7205 10.8925 5.9965 10.8925ZM10.2025 1.74399C9.6516 1.18945 8.99612 0.749759 8.27404 0.45039C7.55197 0.151022 6.77767 -0.00206864 5.996 -1.00288e-05C2.719 -1.00288e-05 0.051 2.66749 0.05 5.94599C0.0484815 6.98937 0.322187 8.01468 0.8435 8.91849L0 12L3.152 11.173C4.02394 11.6481 5.00105 11.897 5.994 11.897H5.9965C9.2735 11.897 11.9415 9.22949 11.9425 5.95049C11.9449 5.16913 11.7924 4.39504 11.4937 3.67301C11.195 2.95097 10.7562 2.29533 10.2025 1.74399Z"
                    fill={`${isScrolled ? "#494949" : "#fff"}`}
                  />
                </svg>
                <div className="nav-contact-info-num">966554482522</div>
              </div>

              {/* <Link to='/mypackages' className="nav-contact-info-container">
                <svg xmlns="http://www.w3.org/2000/svg"  version="1.1" width="20" height="20" viewBox="0 0 256 256" >
                  <g  transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                    <path d="M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 45 22.007 c 8.899 0 16.14 7.241 16.14 16.14 c 0 8.9 -7.241 16.14 -16.14 16.14 c -8.9 0 -16.14 -7.24 -16.14 -16.14 C 28.86 29.248 36.1 22.007 45 22.007 z M 45 83.843 c -11.135 0 -21.123 -4.885 -27.957 -12.623 c 3.177 -5.75 8.144 -10.476 14.05 -13.341 c 2.009 -0.974 4.354 -0.958 6.435 0.041 c 2.343 1.126 4.857 1.696 7.473 1.696 c 2.615 0 5.13 -0.571 7.473 -1.696 c 2.083 -1 4.428 -1.015 6.435 -0.041 c 5.906 2.864 10.872 7.591 14.049 13.341 C 66.123 78.957 56.135 83.843 45 83.843 z"  transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" fill={`${isScrolled ? '#494949' : '#fff'}`}/>
                  </g>
                </svg>
              </Link> */}
              {!isLoggedIn && (
                <Link
                  to="/login"
                  className="nav-contact-info-container"
                  style={{ cursor: "pointer" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="18"
                    height="18"
                    viewBox="0 0 256 256"
                  >
                    <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                      <path
                        d="M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 45 22.007 c 8.899 0 16.14 7.241 16.14 16.14 c 0 8.9 -7.241 16.14 -16.14 16.14 c -8.9 0 -16.14 -7.24 -16.14 -16.14 C 28.86 29.248 36.1 22.007 45 22.007 z M 45 83.843 c -11.135 0 -21.123 -4.885 -27.957 -12.623 c 3.177 -5.75 8.144 -10.476 14.05 -13.341 c 2.009 -0.974 4.354 -0.958 6.435 0.041 c 2.343 1.126 4.857 1.696 7.473 1.696 c 2.615 0 5.13 -0.571 7.473 -1.696 c 2.083 -1 4.428 -1.015 6.435 -0.041 c 5.906 2.864 10.872 7.591 14.049 13.341 C 66.123 78.957 56.135 83.843 45 83.843 z"
                        transform=" matrix(1 0 0 1 0 0) "
                        stroke-linecap="round"
                        fill={`${isScrolled ? "#494949" : "#fff"}`}
                      />
                    </g>
                  </svg>

                  <div className="nav-user-title">{t("LogIn")}</div>
                </Link>
              )}

              {isLoggedIn && (
                <div
                  ref={dropdownRef}
                  className="nav-user-menu nav-contact-info-container"
                  style={{ position: "relative" }}
                >
                  <div
                    onClick={toggleDropdown}
                    className="nav-contact-info-container"
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      width="18"
                      height="18"
                      viewBox="0 0 256 256"
                    >
                      <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                        <path
                          d="M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 45 22.007 c 8.899 0 16.14 7.241 16.14 16.14 c 0 8.9 -7.241 16.14 -16.14 16.14 c -8.9 0 -16.14 -7.24 -16.14 -16.14 C 28.86 29.248 36.1 22.007 45 22.007 z M 45 83.843 c -11.135 0 -21.123 -4.885 -27.957 -12.623 c 3.177 -5.75 8.144 -10.476 14.05 -13.341 c 2.009 -0.974 4.354 -0.958 6.435 0.041 c 2.343 1.126 4.857 1.696 7.473 1.696 c 2.615 0 5.13 -0.571 7.473 -1.696 c 2.083 -1 4.428 -1.015 6.435 -0.041 c 5.906 2.864 10.872 7.591 14.049 13.341 C 66.123 78.957 56.135 83.843 45 83.843 z"
                          transform=" matrix(1 0 0 1 0 0) "
                          stroke-linecap="round"
                          fill={`${isScrolled ? "#494949" : "#fff"}`}
                        />
                      </g>
                    </svg>
                  </div>

                  {showDropdown && (
                    <div
                      className="nav-dropdown"
                      style={{
                        position: "absolute",
                        padding: "10px 0 14px",
                        top: "100%",
                        right: -45,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <Link
                        to="/profile"
                        className="dropdown-item"
                        onClick={() => setShowDropdown(false)}
                      >
                        {t("MyProfile")}
                      </Link>
                      <Link
                        to="/mypackages"
                        className="dropdown-item"
                        onClick={() => setShowDropdown(false)}
                      >
                        {t("MyPackages")}
                      </Link>
                      <div
                        className="dropdown-item"
                        onClick={() => {
                          setShowDropdown(false);
                          handleLogout();
                        }}
                      >
                        {t("LogOut")}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* <div className="nav-contact-info-container">
                <Dropdown className="language-dropdown">
                  <Dropdown.Toggle
                    variant="link"
                    id="language-dropdown"
                    className="language-dropdown"
                  >
                    <div className="nav-contact-info-num">
                      {currentLanguage === "en" ? "EN" : "AR"}
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="language-menu">
                    <Dropdown.Item
                      active={currentLanguage === "en"}
                      onClick={() => changeLanguage("en")}
                    >
                      English
                    </Dropdown.Item>
                    <Dropdown.Item
                      active={currentLanguage === "ar"}
                      onClick={() => changeLanguage("ar")}
                    >
                      العربية
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}

              <div className="nav-contact-info-container language-nav-drop">
                <div
                  className="nav-contact-info-num language-toggle"
                  onClick={() =>
                    changeLanguage(currentLanguage === "en" ? "ar" : "en")
                  }
                  style={{ cursor: "pointer" }}
                >
                  {currentLanguage === "en" ? "AR" : "EN"}
                </div>
              </div>

              <Link
                to={`/${hasCookies ? "mypackages" : "login"}`}
                className="create-package-btn-nav nav-contact-info-container"
              >
                <div className="create-package-btn-title-nav">
                   {t("CreatePackage")}
                </div>
              </Link>

              {/* <div className="nav-contact-info-container country-dropdown">
                <Select
                  options={options}
                  value={options.find((o) => o.value === selectedCountry)}
                  onChange={handleCountryChange}
                  getOptionLabel={(e) => e.label}
                  getOptionValue={(e) => e.value}
                  formatOptionLabel={(option, { context }) =>
                    context === "menu" ? option.label : option.short
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "120px",
                      minHeight: "32px",
                    }),
                    menu: (base) => ({
                      ...base,
                      width: "200px",
                      zIndex: 9999,
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "calc(9 * 40px)",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }),
                    option: (base, state) => ({
                      ...base,
                      padding: "8px 12px",
                      fontSize: "14px",
                      color: state.isSelected ? "white" : "black",
                      cursor: "pointer",
                    }),
                  }}
                />
              </div> */}

              <div className="nav-contact-info-container currency-dropdown">
                <Select
                  classNamePrefix="currency-select"
                  className="currency-select-container"
                  options={options}
                  value={options.find((o) => o.value === preferredCurrency)}
                  onChange={(selectedOption) =>
                    changeCurrency(selectedOption.value)
                  }
                  getOptionLabel={(e) => e.label}
                  getOptionValue={(e) => e.value}
                  formatOptionLabel={(option, { context }) =>
                    context === "menu" ? option.label : option.short
                  }
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  classNames={{
                    singleValue: () => "rs-single-value",
                  }}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: "unset",
                      border: "unset",
                      color: "white",
                      width: "78px",
                      minHeight: "32px",
                      cursor: "pointer",
                      border: state.menuIsOpen ? "unset" : "unset",
                      borderColor: state.menuIsOpen
                        ? "unset"
                        : base.borderColor,
                      boxShadow: "unset",
                      fontSize: "12px",
                    }),
                    menu: (base) => ({
                      ...base,
                      width: "200px",
                      zIndex: 9999,
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "calc(9 * 40px)",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "unset",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      padding: "unset",
                    }),
                    // singleValue: (base) => ({
                    //   ...base,
                    //   color: "white",
                    // }),
                    option: (base, state) => ({
                      ...base,
                      padding: "8px 12px",
                      fontSize: "14px",
                      color: state.isSelected ? "white" : "black",
                      cursor: "pointer",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
